import React from "react";

/**
 * Standard page header: title, subtitle, right-aligned actions and an
 * optional left slot (e.g. icon). Used by every page for hierarchy.
 */
export default function PageHeader({ title, subtitle, icon: Icon, actions, children, className = "" }) {
    return (
        <div className={`flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between ${className}`}>
            <div className="flex items-center gap-3 min-w-0">
                {Icon && (
                    <div className="hidden sm:flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600 dark:bg-primary-500/10 dark:text-primary-400">
                        <Icon className="h-5 w-5" />
                    </div>
                )}
                <div className="min-w-0">
                    <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-2xl">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
                    )}
                </div>
            </div>
            {(actions || children) && (
                <div className="flex flex-wrap items-center gap-2">{actions}{children}</div>
            )}
        </div>
    );
}
